import { normalize } from "common/lib/normalize";
import { getRequestTypes } from "common/services/govt-requests.service";
import { useEffect, useMemo, useState } from "react";
import { Col, FormFeedback, Input, Label, Row } from "reactstrap";

const SelectRequestType = ({ validation }: { validation: any }) => {
  const [data, setData] = useState([]);
  const [, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getRequestTypes({
          pagination: {
            page: 1,
            pageSize: 1000,
          },
          fields: ["name", "code"],
          sort: "id:asc",
        });

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.name}`,
        code: el?.code,
      };
    });
  }, [data]);

  return (
    <>
      <Label htmlFor="noOfPositionsRequested" className="form-label mb-1">
        Type of Request <span className="text-danger me-1 ms-1">*</span>
      </Label>
      <p className="text-muted">
        Which type of Government Support Request would you like to report?
      </p>

      <Row className="g-4  align-items-stretch">
        {
          // Loop through payment modes and display them
          options.map((requestType: any) => {
            let icon = "";
            switch (requestType.code) {
              case "MOBILE_MONEY":
                icon = "ri-cellphone-fill";
                break;
              case "BANK_DEPOSIT":
                icon = "ri-bank-card-fill";
                break;
              case "BANK_TRANSFER":
                icon = "ri-bank-card-fill";
                break;
              case "CHEQUE_DEPOSIT":
                icon = "ri-money-dollar-box-fill";
                break;
              case "CASH":
                icon = "ri-hand-coin-fill";
                break;
              default:
                icon = "ri-hand-coin-fill";
                break;
            }
            return (
              <Col lg={3} sm={6} key={requestType.value}>
                <div className="">
                  <div className="form-check card-radio ">
                    <Input
                      id={`paymentMethod${requestType.value}`}
                      name="requestType"
                      type="radio"
                      className="form-check-input"
                      onChange={() => {
                        validation.setFieldValue(
                          "requestType",
                          requestType.code
                        );
                        validation.setFieldError("requestType", "");
                      }}
                      defaultChecked={
                        validation.values.requestType === requestType.code
                      }
                      checked={
                        validation.values.requestType === requestType.code
                      }
                    />
                    <Label
                      className="form-check-label"
                      htmlFor={`paymentMethod${requestType.value}`}
                      style={{
                        minHeight: "80px",
                      }}
                    >
                      <span className="fs-16 text-muted me-2">
                        <i className={`${icon} align-bottom`}></i>
                      </span>
                      <span className="fs-14 text-wrap">
                        {requestType.label}
                      </span>
                    </Label>
                  </div>
                </div>
                {validation.errors.requestType && (
                  <FormFeedback invalid>
                    {validation.errors.requestType}
                  </FormFeedback>
                )}
              </Col>
            );
          })
        }
      </Row>
    </>
  );
};

export default SelectRequestType;
